import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { decryptToken } from "./utils/getToken";
import userImg from "../Img/User img2.png";
import "./CRMUpdatedVersion/LeadsUpdatedVersion.css";

const DETAIL_FIELDS = [
    { key: "main_id", label: "User ID" },
    { key: "full_name", label: "Full Name" },
    { key: "business_name", label: "Business Name" },
    { key: "email", label: "Email" },
    { key: "mobile", label: "Mobile" },
    { key: "category", label: "Category" },
    { key: "type", label: "Type" },
    { key: "status", label: "Status" },
    { key: "website_link", label: "Website" },
    { key: "tag_line", label: "Tag Line" },
    { key: "office_address", label: "Office Address" },
    { key: "google_address", label: "Google Address" },
    { key: "custom_note", label: "Custom Note" },
    { key: "taxNo", label: "Tax No" },
    { key: "orignal_logoname", label: "Logo Name" },
    { key: "copyrightto_admin", label: "Copyright to Admin" },
];

const formatValue = (key, value) => {
    if (value === null || value === undefined || value === "") return "N/A";
    if (key === "copyrightto_admin") return value ? "Yes" : "No";
    return String(value);
};

const UserRegisterViewModal = ({ isOpen, setIsOpen, adminId }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(false);
    const urlmain = API_BASE_URL;
    const token = decryptToken("accessToken") || "";

    useEffect(() => {
        if (!isOpen || !adminId) {
            setAdmin(null);
            return;
        }

        const fetchAdmin = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${urlmain}/register/${adminId}`, {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const res = await response.json();
                if (response.ok && res.user) {
                    setAdmin(res.user);
                } else {
                    toast.error(res.message || "Failed to load admin details");
                    setIsOpen(false);
                }
            } catch (error) {
                console.error(error);
                toast.error("Failed to load admin details");
                setIsOpen(false);
            } finally {
                setLoading(false);
            }
        };

        fetchAdmin();
    }, [isOpen, adminId, urlmain, token, setIsOpen]);

    if (!isOpen) return null;

    const profileSrc = admin?.profilePic
        ? `${urlmain}/logo/${String(admin.profilePic).replace(/\\/g, "/")}`
        : userImg;

    return (
        <div className="ls-enquiry-modal" onClick={() => setIsOpen(false)}>
            <div
                className="ls-enquiry-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="quotation-header">
                    <h2>Admin Details</h2>
                    <button
                        type="button"
                        className="quotation-close"
                        onClick={() => setIsOpen(false)}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>

                {loading ? (
                    <p style={{ textAlign: "center", padding: "1rem 0" }}>Loading...</p>
                ) : admin ? (
                    <div className="leads-detail-modal-body-crm">
                        <div style={{ textAlign: "center", marginBottom: "12px" }}>
                            <img
                                src={profileSrc}
                                alt={admin.full_name || "Admin"}
                                onError={(e) => {
                                    e.currentTarget.src = userImg;
                                }}
                                style={{
                                    width: "72px",
                                    height: "72px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                }}
                            />
                        </div>
                        <div className="lead-details-list-crm">
                            {DETAIL_FIELDS.map(({ key, label }) => (
                                <div key={key}>
                                    <strong>{label}:</strong> {formatValue(key, admin[key])}
                                </div>
                            ))}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default UserRegisterViewModal;
